// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  /* Brand - HIDROVEN Navy */
  --primary: #162A5A;
  --primary-dark: #0D1E42;
  --primary-darker: #08122B;
  --primary-light: #1E3A7A;
  --primary-ultralight: #E8EFF9;
  --primary-50: #F0F4FA;
  --primary-100: #E1E8F4;
  --primary-200: #C2D0E9;
  --primary-300: #A3B9DE;
  --primary-400: #84A1D3;
  --primary-500: #162A5A;
  --primary-600: #12244F;
  --primary-700: #0D1E42;

  /* Accent - HIDROVEN Cyan */
  --accent: #4AADE3;
  --accent-dark: #2D8EC4;
  --accent-light: #E0F4FF;
  
  /* Sidebar Gradients */
  --sidebar-bg-start: #0D1E42;
  --sidebar-bg-end: #162A5A;

  /* Semantic - States (Tricolor / Natural) */
  --success: #2E7D32;
  --success-dark: #1B5E20;
  --success-light: #E8F5E9;
  --warning: #E65100;
  --warning-dark: #BF360C;
  --warning-light: #FFF3E0;
  --danger: #B71C1C;
  --danger-dark: #7F0000;
  --danger-light: #FFEBEE;
  --info: #0891b2;
  --info-light: #cffafe;
  --purple: #7c3aed;
  --purple-light: #ede9fe;
  --teal: #0d9488;
  --teal-light: #ccfbf1;

  /* State-specific colors */
  --state-borrador: #6b7280;
  --state-evaluacion: #d97706;
  --state-verificacion: #0891b2;
  --state-aprobado: #0d9488;
  --state-enviado: #1e3a5f;
  --state-recibido: #0f766e;
  --state-rechazado: #b91c1c;

  /* Neutral Grays */
  --gray-50: #f8fafc;
  --gray-100: #f1f5f9;
  --gray-200: #e2e8f0;
  --gray-300: #cbd5e1;
  --gray-400: #94a3b8;
  --gray-500: #64748b;
  --gray-600: #475569;
  --gray-700: #334155;
  --gray-800: #1e293b;
  --gray-900: #0f172a;
  --white: #ffffff;

  /* Backgrounds */
  --bg: #EEF4FC;
  --bg-card: #ffffff;
  --bg-subtle: #f8fafc;

  /* Text */
  --text: #0f172a;
  --text-secondary: #475569;
  --text-muted: #64748b;

  /* Borders */
  --border: #e2e8f0;
  --border-light: #f1f5f9;

  /* Shadows - Soft & Professional */
  --shadow-xs: 0 1px 2px 0 rgba(15, 23, 42, 0.04);
  --shadow-sm: 0 1px 3px 0 rgba(15, 23, 42, 0.06), 0 1px 2px -1px rgba(15, 23, 42, 0.06);
  --shadow: 0 4px 6px -1px rgba(15, 23, 42, 0.08), 0 2px 4px -2px rgba(15, 23, 42, 0.08);
  --shadow-md: 0 10px 15px -3px rgba(15, 23, 42, 0.08), 0 4px 6px -4px rgba(15, 23, 42, 0.08);
  --shadow-lg: 0 20px 25px -5px rgba(15, 23, 42, 0.1), 0 8px 10px -6px rgba(15, 23, 42, 0.1);
  --shadow-xl: 0 25px 50px -12px rgba(15, 23, 42, 0.15);

  /* Border Radius - More Rounded */
  --radius-xs: 6px;
  --radius-sm: 8px;
  --radius: 10px;
  --radius-md: 14px;
  --radius-lg: 18px;
  --radius-xl: 24px;
  --radius-full: 9999px;

  /* Transitions */
  --transition-fast: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition: 200ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-slow: 300ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-bounce: 350ms cubic-bezier(0.34, 1.56, 0.64, 1);

  /* Typography */
  --font-sans: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  --font-mono: 'Fira Code', ui-monospace, SFMono-Regular, monospace;

  /* Layout */
  --header-height: 72px;
  --sidebar-width: 270px;
  --sidebar-collapsed: 72px;
}

[data-theme="dark"] {
  --bg: #1a1c23;
  --bg-card: #252836;
  --bg-subtle: #2d303e;
  
  --text: #ffffff;
  --text-secondary: #e0e0e0;
  --text-muted: #d0d0d0;
  
  --border: #374151;
  --border-light: #2d303e;

  /* Modifying specific semantic/structural colors for dark mode */
  --primary-ultralight: #252836;
  --primary-50: #1a1c23;
  --primary-100: #2d303e;
  --primary-200: #374151;

  --shadow-xs: none;
  --shadow-sm: none;
  --shadow: none;
  --shadow-md: none;
  --shadow-lg: none;
  --shadow-xl: none;
}

body {
  font-family: var(--font-sans);
  background-color: var(--bg);
  color: var(--text);
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
}

::selection {
  background: var(--primary-light);
  color: var(--primary-darker);
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: var(--gray-100);
  border-radius: var(--radius-full);
}

::-webkit-scrollbar-thumb {
  background: var(--gray-300);
  border-radius: var(--radius-full);
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

::-webkit-scrollbar-thumb:hover {
  background: var(--gray-400);
}

/* Layout */
.layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.layout-content {
  display: flex;
  flex: 1 1;
  margin-top: var(--header-height);
}

.main-content {
  flex: 1 1;
  padding: 24px;
  background: var(--bg);
  overflow-y: auto;
  min-height: calc(100vh - var(--header-height));
}

.loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  gap: 16px;
  font-size: 16px;
  color: var(--text-muted);
}

.loading::before {
  content: '';
  width: 40px;
  height: 40px;
  border: 3px solid var(--gray-200);
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

/* Header */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  height: var(--header-height);
  background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 50%, var(--primary-darker) 100%);
  color: var(--white);
  box-shadow: var(--shadow-md);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  backdrop-filter: blur(10px);
}

.header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.logo {
  font-size: 20px;
  font-weight: 800;
  margin: 0;
  letter-spacing: -0.5px;
  text-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.subtitle {
  font-size: 12px;
  opacity: 0.85;
  font-weight: 400;
  letter-spacing: 0.3px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 500;
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: var(--radius-full);
  background: rgba(255,255,255,0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  border: 2px solid rgba(255,255,255,0.3);
  transition: var(--transition);
}

.user-avatar:hover {
  background: rgba(255,255,255,0.3);
  transform: scale(1.05);
}

.user-role {
  font-size: 11px;
  opacity: 0.75;
  font-weight: 400;
  background: rgba(255,255,255,0.15);
  padding: 2px 8px;
  border-radius: var(--radius-full);
}

.btn-logout {
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: var(--white);
  border-radius: var(--radius);
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: var(--transition);
  backdrop-filter: blur(4px);
}

.btn-logout:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.btn-logout:active {
  transform: translateY(0);
}

/* Sidebar */
.sidebar {
  width: var(--sidebar-width);
  background: var(--bg-card);
  border-right: 1px solid var(--border);
  padding: 16px 0;
  box-shadow: var(--shadow-xs);
  position: fixed;
  top: var(--header-height);
  left: 0;
  bottom: 0;
  overflow-y: auto;
  z-index: 100;
  transition: var(--transition);
}

.menu {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu li a {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  margin: 4px 12px;
  text-decoration: none;
  color: var(--gray-600);
  font-size: 14px;
  font-weight: 500;
  transition: var(--transition);
  border-radius: var(--radius);
  position: relative;
  overflow: hidden;
}

.menu li a::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: var(--primary);
  border-radius: 0 2px 2px 0;
  transform: scaleY(0);
  transition: var(--transition);
}

.menu li a:hover {
  background: var(--gray-50);
  color: var(--primary);
  transform: translateX(4px);
}

.menu li a:hover::before {
  transform: scaleY(1);
}

.menu li a.active {
  background: var(--primary-ultralight);
  color: var(--primary);
  font-weight: 600;
}

.menu li a.active::before {
  transform: scaleY(1);
}

.menu .icon {
  font-size: 18px;
  width: 24px;
  text-align: center;
  transition: var(--transition);
}

.menu li a:hover .icon {
  transform: scale(1.1);
}

/* Cards */
.card {
  background: var(--bg-card);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  padding: 24px;
  transition: var(--transition);
  border: 1px solid var(--border);
}

.card:hover {
  box-shadow: var(--shadow);
}

/* Stats - Summary Cards with Icons */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.stat-card {
  background: var(--bg-card);
  padding: 20px;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border);
  display: flex;
  align-items: center;
  gap: 16px;
  transition: var(--transition);
}

.stat-card:hover {
  box-shadow: var(--shadow);
  transform: translateY(-2px);
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: var(--radius);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
}

.stat-icon.primary {
  background: var(--primary-ultralight);
  color: var(--primary);
}

.stat-icon.success {
  background: var(--success-light);
  color: var(--success);
}

.stat-icon.warning {
  background: var(--warning-light);
  color: var(--warning);
}

.stat-icon.danger {
  background: var(--danger-light);
  color: var(--danger);
}

.stat-icon.info {
  background: var(--info-light);
  color: var(--info);
}

.stat-content {
  flex: 1 1;
  min-width: 0;
}

.stat-card h3 {
  font-size: 12px;
  color: var(--text-muted);
  margin-bottom: 6px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-number {
  font-size: 28px;
  font-weight: 700;
  color: var(--text);
  line-height: 1;
}

/* Tables */
.table-container {
  background: var(--bg-card);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  overflow-x: auto;
  border: 1px solid var(--border);
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th {
  background: var(--bg);
  padding: 14px 18px;
  text-align: center;
  font-weight: 600;
  color: var(--primary);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  border-bottom: 2px solid var(--accent);
  white-space: nowrap;
}

.table td {
  padding: 16px 18px;
  font-size: 14px;
  border-bottom: 1px solid var(--border-light);
  color: var(--text-secondary);
  vertical-align: middle;
}

.table tbody tr {
  transition: var(--transition);
}

.table tbody tr:nth-child(even) {
  background: var(--bg-subtle);
}

.table tbody tr:hover {
  background: var(--primary-ultralight);
}

.table tbody tr:last-child td {
  border-bottom: none;
}

/* Badges - Capsule Style */
.badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: var(--radius-full);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.3px;
  transition: var(--transition);
}

.badge:hover {
  transform: scale(1.05);
}

.badge-primary { background: var(--primary-ultralight); color: var(--primary); }
.badge-success { background: var(--success-light); color: var(--success-dark); }
.badge-warning { background: var(--warning-light); color: var(--warning-dark); }
.badge-danger { background: var(--danger-light); color: var(--danger-dark); }
.badge-info { background: var(--info-light); color: var(--info); }
.badge-purple { background: var(--purple-light); color: var(--purple); }
.badge-teal { background: var(--teal-light); color: var(--teal); }

/* Estado Badges - Semantic Colors */
.estado-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: var(--radius-full);
  font-size: 12px;
  font-weight: 600;
  transition: var(--transition);
  border: 1px solid transparent;
  white-space: nowrap;
  width: max-content;
}

.estado-badge:hover {
  transform: scale(1.05);
}

/* State-specific colors - Professional & Sober */
.estado-badge.borrador {
  background: var(--gray-100);
  color: var(--state-borrador);
  border-color: var(--gray-200);
}

.estado-badge.en_evaluacion_factibilidad {
  background: var(--warning-light);
  color: var(--state-evaluacion);
  border-color: var(--warning);
}

.estado-badge.verificacion_final {
  background: var(--info-light);
  color: var(--state-verificacion);
  border-color: var(--info);
}

.estado-badge.aprobado_para_envio {
  background: var(--success-light);
  color: var(--state-aprobado);
  border-color: var(--success);
}

.estado-badge.enviado {
  background: var(--primary-ultralight);
  color: var(--state-enviado);
  border-color: var(--primary-200);
}

.estado-badge.recibido {
  background: var(--teal-light);
  color: var(--state-recibido);
  border-color: var(--teal);
}

.estado-badge.rechazado {
  background: var(--danger-light);
  color: var(--state-rechazado);
  border-color: var(--danger);
}

.role-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 4px 12px;
  border-radius: var(--radius-full);
  background: var(--primary-ultralight);
  color: var(--primary);
  font-size: 12px;
  font-weight: 600;
  transition: var(--transition);
  white-space: nowrap;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: var(--radius-full);
  font-size: 12px;
  font-weight: 600;
  transition: var(--transition);
}

.status-badge::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.status-badge.activo {
  background: var(--success-light);
  color: var(--success-dark);
}

.status-badge.inactivo {
  background: var(--danger-light);
  color: var(--danger-dark);
}

.tipo-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: var(--radius-full);
  font-size: 12px;
  font-weight: 600;
  transition: var(--transition);
}

.tipo-badge.emisora {
  background: var(--primary-ultralight);
  color: var(--primary);
  border: 1px solid var(--primary-200);
}

.tipo-badge.receptora {
  background: var(--purple-light);
  color: var(--purple);
  border: 1px solid var(--purple);
}

/* Buttons - estilo Tailwind/Bootstrap */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 20px;
  border: none;
  border-radius: var(--radius);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  text-decoration: none;
  white-space: nowrap;
  font-family: var(--font-sans);
  position: relative;
  overflow: hidden;
}

.btn:active {
  transform: scale(0.97);
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

/* Primary - Navy Blue Professional */
.btn-primary {
  background: var(--primary);
  color: #ffffff;
  box-shadow: 0 1px 3px rgba(30, 58, 95, 0.2), 0 1px 2px rgba(0, 0, 0, 0.06);
}

.btn-primary:hover:not(:disabled) {
  background: var(--primary-dark);
  box-shadow: 0 4px 12px rgba(30, 58, 95, 0.25), 0 2px 4px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

/* Secondary - Clean Outline */
.btn-secondary {
  background: #ffffff;
  color: var(--text-secondary);
  border: 1.5px solid var(--border);
  box-shadow: var(--shadow-xs);
}

.btn-secondary:hover:not(:disabled) {
  background: var(--gray-50);
  border-color: var(--gray-300);
  color: var(--text);
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

/* Success - Teal Professional */
.btn-success {
  background: var(--success);
  color: #ffffff;
  box-shadow: 0 1px 3px rgba(13, 148, 136, 0.2), 0 1px 2px rgba(0, 0, 0, 0.06);
}

.btn-success:hover:not(:disabled) {
  background: var(--success-dark);
  box-shadow: 0 4px 12px rgba(13, 148, 136, 0.25), 0 2px 4px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

/* Danger - Muted Red */
.btn-danger {
  background: var(--danger);
  color: #ffffff;
  box-shadow: 0 1px 3px rgba(185, 28, 28, 0.2), 0 1px 2px rgba(0, 0, 0, 0.06);
}

.btn-danger:hover:not(:disabled) {
  background: var(--danger-dark);
  box-shadow: 0 4px 12px rgba(185, 28, 28, 0.25), 0 2px 4px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

/* Warning - Amber Professional */
.btn-warning {
  background: var(--warning);
  color: #ffffff;
  box-shadow: 0 1px 3px rgba(217, 119, 6, 0.2), 0 1px 2px rgba(0, 0, 0, 0.06);
}

.btn-warning:hover:not(:disabled) {
  background: var(--warning-dark);
  box-shadow: 0 4px 12px rgba(217, 119, 6, 0.25), 0 2px 4px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

/* Info - Cyan Professional */
.btn-info {
  background: var(--info);
  color: #ffffff;
  box-shadow: 0 1px 3px rgba(8, 145, 178, 0.2), 0 1px 2px rgba(0, 0, 0, 0.06);
}

.btn-info:hover:not(:disabled) {
  background: #0e7490;
  box-shadow: 0 4px 12px rgba(8, 145, 178, 0.25), 0 2px 4px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

/* Outline - Clean Border */
.btn-outline {
  background: #ffffff;
  color: var(--text-secondary);
  border: 1.5px solid var(--border);
  box-shadow: var(--shadow-xs);
}

.btn-outline:hover:not(:disabled) {
  background: var(--gray-50);
  border-color: var(--gray-300);
  color: var(--text);
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

.btn-outline:hover:not(:disabled) {
  background: var(--gray-50);
  border-color: var(--gray-400);
  color: var(--gray-900);
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

/* Ghost - Tailwind hover:bg-gray-100 */
.btn-ghost {
  background: transparent;
  color: var(--gray-600);
  border: 1.5px solid transparent;
}

.btn-ghost:hover:not(:disabled) {
  background: var(--gray-100);
  color: var(--gray-900);
}

/* Soft/Light - Tailwind bg-blue-100 text-blue-700 */
.btn-soft-primary {
  background: var(--primary-light);
  color: var(--primary-dark);
  border: 1px solid transparent;
}

.btn-soft-primary:hover:not(:disabled) {
  background: var(--primary);
  color: #ffffff;
}

.btn-soft-success {
  background: var(--success-light);
  color: var(--success-dark);
  border: 1px solid transparent;
}

.btn-soft-success:hover:not(:disabled) {
  background: var(--success);
  color: #ffffff;
}

.btn-soft-danger {
  background: var(--danger-light);
  color: var(--danger-dark);
  border: 1px solid transparent;
}

.btn-soft-danger:hover:not(:disabled) {
  background: var(--danger);
  color: #ffffff;
}

/* Link */
.btn-link {
  color: var(--primary);
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: var(--transition);
  background: none;
  border: none;
  padding: 4px 8px;
  border-radius: var(--radius-xs);
}

.btn-link:hover {
  background: var(--primary-ultralight);
  color: var(--primary-dark);
}

/* Small buttons */
.btn-small, .btn-sm {
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 500;
  border-radius: var(--radius-sm);
}

/* Large buttons */
.btn-lg {
  padding: 14px 28px;
  font-size: 16px;
  border-radius: var(--radius-md);
}

/* Action buttons - Professional Soft Style */
.btn-approve {
  background: var(--success-light);
  color: var(--success-dark);
  border: 1px solid var(--success);
}

.btn-approve:hover:not(:disabled) {
  background: var(--success);
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(13, 148, 136, 0.25);
  transform: translateY(-1px);
}

.btn-reject {
  background: var(--danger-light);
  color: var(--danger-dark);
  border: 1px solid var(--danger);
}

.btn-reject:hover:not(:disabled) {
  background: var(--danger);
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(185, 28, 28, 0.25);
  transform: translateY(-1px);
}

.btn-edit {
  background: var(--warning-light);
  color: var(--warning-dark);
  border: 1px solid var(--warning);
}

.btn-edit:hover:not(:disabled) {
  background: var(--warning);
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(217, 119, 6, 0.25);
  transform: translateY(-1px);
}

.btn-password {
  background: var(--purple-light);
  color: var(--purple);
  border: 1px solid var(--purple);
}

.btn-password:hover:not(:disabled) {
  background: var(--purple);
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(124, 58, 237, 0.25);
  transform: translateY(-1px);
}

/* View detail button - eye icon style */
.btn-view {
  background: var(--primary-ultralight);
  color: var(--primary);
  border: 1px solid var(--primary-200);
}

.btn-view:hover:not(:disabled) {
  background: var(--primary);
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(30, 58, 95, 0.25);
  transform: translateY(-1px);
}

/* Spinner inside buttons */
.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

/* Forms */
.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 16px;
}

.form-group label {
  font-size: 13px;
  font-weight: 600;
  color: var(--gray-700);
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 10px 14px;
  border: 1.5px solid var(--border);
  border-radius: var(--radius);
  font-size: 14px;
  transition: var(--transition);
  background: var(--white);
  font-family: var(--font-sans);
}

.form-group input:hover,
.form-group select:hover,
.form-group textarea:hover {
  border-color: var(--gray-400);
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px var(--primary-light);
  transform: translateY(-1px);
}

.form-group input:disabled,
.form-group select:disabled {
  background: var(--gray-100);
  cursor: not-allowed;
  opacity: 0.7;
}

.form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

/* Error messages */
.error-message {
  background: var(--danger-light);
  color: var(--danger-dark);
  padding: 14px 16px;
  border-radius: var(--radius);
  font-size: 14px;
  margin-bottom: 16px;
  border-left: 4px solid var(--danger);
  animation: slideInLeft 0.3s ease;
}

/* Empty state */
.empty-message {
  text-align: center;
  color: var(--text-muted);
  padding: 60px 24px;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.empty-message::before {
  content: '📋';
  font-size: 48px;
  opacity: 0.5;
}

/* Modal */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(8px);
  animation: fadeIn 0.2s ease;
}

.modal-content {
  background: var(--bg-card);
  padding: 28px;
  border-radius: var(--radius-lg);
  width: 90%;
  max-width: 520px;
  box-shadow: var(--shadow-xl);
  max-height: 90vh;
  overflow-y: auto;
  animation: modalSlideIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  border: 1px solid var(--border);
}

.modal-content.modal-lg {
  max-width: 720px;
}

.modal-content h3 {
  margin-bottom: 20px;
  color: var(--gray-900);
  font-size: 20px;
  font-weight: 700;
}

.modal-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
}

/* Section headers */
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--border);
}

.section-header h3 {
  font-size: 20px;
  font-weight: 700;
  color: var(--gray-900);
}

/* Filtros */
.filtros-container {
  background: var(--bg-card);
  padding: 20px;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  margin-bottom: 24px;
  border: 1px solid var(--border);
}

.filtros-container h3 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  color: var(--gray-800);
}

.filtros-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.filtros-rapidos {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

/* Animations */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes fadeInDown {
  from { opacity: 0; transform: translateY(-20px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes fadeInLeft {
  from { opacity: 0; transform: translateX(-20px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes fadeInRight {
  from { opacity: 0; transform: translateX(20px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes slideInLeft {
  from { opacity: 0; transform: translateX(-100%); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes slideInUp {
  from { opacity: 0; transform: translateY(100%); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes modalSlideIn {
  from { opacity: 0; transform: scale(0.9) translateY(20px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
}

@keyframes shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

.animate-fade-in {
  animation: fadeIn 0.4s ease;
}

.animate-fade-in-up {
  animation: fadeInUp 0.5s ease;
}

.animate-fade-in-down {
  animation: fadeInDown 0.4s ease;
}

.animate-slide-in-left {
  animation: fadeInLeft 0.4s ease;
}

.animate-slide-in-right {
  animation: fadeInRight 0.4s ease;
}

.animate-bounce {
  animation: bounce 0.5s ease;
}

.animate-pulse {
  animation: pulse 2s ease infinite;
}

.stagger-1 { animation-delay: 0.05s; }
.stagger-2 { animation-delay: 0.1s; }
.stagger-3 { animation-delay: 0.15s; }
.stagger-4 { animation-delay: 0.2s; }
.stagger-5 { animation-delay: 0.25s; }
.stagger-6 { animation-delay: 0.3s; }

/* Skeleton loading */
.skeleton {
  background: linear-gradient(90deg, var(--gray-100) 25%, var(--gray-200) 50%, var(--gray-100) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: var(--radius);
}

/* Responsive */
@media (max-width: 1024px) {
  .main-content {
    padding: 20px;
  }

  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .main-content {
    padding: 16px;
    margin-left: 0;
  }

  .stats-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .header {
    padding: 0 16px;
  }

  .subtitle {
    display: none;
  }

  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .filtros-grid {
    grid-template-columns: 1fr;
  }

  .table-container {
    overflow-x: auto;
  }

  .table {
    min-width: 600px;
  }

  .modal-content {
    width: 95%;
    padding: 20px;
  }
}

@media (max-width: 480px) {
  .header-right {
    gap: 8px;
  }

  .user-info span:not(.user-avatar):not(.user-role) {
    display: none;
  }

  .btn-logout {
    padding: 6px 10px;
    font-size: 12px;
  }

  .stat-card {
    padding: 16px;
  }

  .stat-number {
    font-size: 28px;
  }
}

/* Grupo de input de cédula compuesto (V/E + Número) */
.cedula-input-group {
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
}

.cedula-input-group .select-nacionalidad {
  width: 80px;
  min-width: 80px;
  padding: 10px 12px;
  border-radius: var(--radius-sm, 8px);
  border: 1.5px solid var(--border, #cbd5e1);
  background-color: var(--bg-card, #ffffff);
  color: var(--text, #0f172a);
  font-weight: 600;
  outline: none;
  transition: var(--transition, all 0.2s);
}

.cedula-input-group .select-nacionalidad:focus {
  border-color: var(--primary, #1e3a5f);
  box-shadow: 0 0 0 3px rgba(30, 58, 95, 0.15);
}

[data-theme="dark"] .cedula-input-group .select-nacionalidad {
  border-color: var(--gray-700, #475569);
  background-color: var(--gray-800, #1e293b);
  color: var(--gray-100, #f8fafc);
}

.cedula-input-group .input-cedula-num {
  flex: 1 1;
}

/* Unified Table Card Layout (from Dashboard) */
.table-card-container {
  background: var(--bg-card);
  border-radius: var(--radius-md);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  margin-top: 24px;
}

.table-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 24px;
  background: var(--gray-50);
  border-bottom: 1px solid var(--border);
}

.table-card-header h3 {
  font-size: 16px;
  font-weight: 700;
  color: var(--gray-800);
  margin: 0;
}

.table-count-pill {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--text-muted);
  background: var(--gray-200);
  padding: 4px 12px;
  border-radius: var(--radius-full);
}

.table-search-bar {
  padding: 15px 24px;
  border-bottom: 1px solid var(--border-light);
  background: var(--white);
}

.table-search-input {
  width: 100%;
  max-width: 400px;
  padding: 10px 15px;
  border-radius: 8px;
  border: 1px solid var(--border);
  outline: none;
  font-size: 14px;
  transition: var(--transition);
  background-color: var(--white);
  color: var(--text);
}

.table-search-input:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px var(--primary-ultralight);
}

.table-pagination-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 24px;
  border-top: 1px solid var(--border-light);
  background: var(--white);
}

.table-pagination-button {
  padding: 8px 16px;
  border-radius: 6px;
  border: 1px solid var(--border);
  background: var(--white);
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
  color: var(--gray-700);
  transition: var(--transition);
}

.table-pagination-button:hover:not(:disabled) {
  background: var(--gray-50);
  border-color: var(--gray-400);
}

.table-pagination-button:disabled {
  background: var(--gray-100);
  color: var(--text-muted);
  cursor: not-allowed;
  border-color: var(--border-light);
}

.table-pagination-info {
  font-size: 14px;
  color: var(--text-secondary);
  font-weight: 500;
}



[data-theme="dark"] .btn-secondary {
  background: var(--bg-subtle);
  color: #ffffff;
  border-color: var(--border);
}

[data-theme="dark"] .btn-secondary:hover:not(:disabled) {
  background: var(--primary-100);
}

/* Dark mode Bandeja fixes */
[data-theme="dark"] .table-card-header {
  background: var(--bg-card);
  border-bottom-color: var(--border);
}

[data-theme="dark"] .table-card-header h3 {
  color: #ffffff;
}

[data-theme="dark"] .table th {
  background: var(--bg-subtle);
  color: #ffffff;
  border-bottom-color: var(--border);
  font-weight: bold;
}

[data-theme="dark"] .table td strong {
  color: #ffffff;
  font-weight: bold;
}

[data-theme="dark"] .table-search-bar {
  background: var(--bg-card);
  border-bottom-color: var(--border);
}

[data-theme="dark"] .table-search-input {
  background: var(--bg-subtle);
  color: #ffffff;
  border-color: var(--border);
}

[data-theme="dark"] .table-pagination-bar {
  background: var(--bg-card);
  border-top-color: var(--border);
}

[data-theme="dark"] .table-pagination-button {
  background: var(--bg-subtle);
  color: #ffffff;
  border-color: var(--border);
}

[data-theme="dark"] .table-pagination-button:disabled {
  background: var(--bg-card);
  color: var(--text-muted);
}

[data-theme="dark"] .table-pagination-info {
  color: #ffffff;
}

[data-theme="dark"] .enviados-header h2 {
  color: #ffffff;
}

[data-theme="dark"] .table-count-pill {
  color: #ffffff;
  background: var(--primary);
  border: 1px solid var(--border);
}

[data-theme="dark"] .btn-link {
  color: #60a5fa;
}

[data-theme="dark"] .btn-link:hover {
  color: #93c5fd;
}

/* Global dark mode override for disabled inputs and selects */
[data-theme="dark"] .form-group input:disabled,
[data-theme="dark"] .form-group select:disabled {
  background: var(--bg-subtle);
  color: var(--text-muted);
  border-color: var(--border);
  opacity: 0.8;
}

/* Global dark mode overrides for form group controls */
[data-theme="dark"] .form-group input,
[data-theme="dark"] .form-group select,
[data-theme="dark"] .form-group textarea {
  background-color: var(--bg-subtle);
  color: var(--text);
  border-color: var(--border);
}

[data-theme="dark"] .form-group input:hover,
[data-theme="dark"] .form-group select:hover,
[data-theme="dark"] .form-group textarea:hover {
  border-color: var(--gray-500);
}

[data-theme="dark"] .form-group input:focus,
[data-theme="dark"] .form-group select:focus,
[data-theme="dark"] .form-group textarea:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25);
}

[data-theme="dark"] .form-group label {
  color: var(--text-secondary);
}

/* Pestañas Globales (Pill style) */
.reporte-tab-btn {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  padding: 12px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: normal;
  transition: all 0.2s;
  background: transparent;
  color: var(--text-muted);
}

.reporte-tab-btn.active {
  background: #f1f5f9;
  color: #0f172a;
  font-weight: bold;
}

[data-theme="dark"] .reporte-tab-btn.active {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

[data-theme="dark"] .reporte-tab-btn:not(.active) {
  color: var(--text-muted);
}

[data-theme="dark"] .reporte-tab-btn:hover:not(.active) {
  background: rgba(255, 255, 255, 0.05);
  color: #ffffff;
}

/* =========================================
   RESPONSIVE DESIGN (Tablets y Móviles)
   Añadido sin romper el diseño de escritorio
   ========================================= */

@media (max-width: 992px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  :root {
    --header-height: 60px;
  }

  .layout-content {
    flex-direction: column;
  }
  
  .main-content {
    padding: 16px;
    width: 100vw;
  }

  /* Header adjustments */
  .header {
    padding: 0 16px;
  }

  .logo-hidroven {
    display: none;
  }

  .user-profile {
    display: none;
  }

  .btn-logout .logout-text {
    display: none;
  }
  
  .btn-logout {
    padding: 8px;
  }

  /* Stats Grid */
  .stats-grid {
    grid-template-columns: 1fr;
  }

  /* Table Container */
  .table-container {
    border-radius: var(--radius-sm);
  }
  
  .table th, .table td {
    padding: 12px;
    font-size: 13px;
  }

  .btn {
    padding: 8px 16px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .header-left {
    gap: 8px;
  }
  
  .logo-ministerio {
    height: 32px;
  }
  
  .main-content {
    padding: 12px;
  }
  
  .table th, .table td {
    padding: 10px 8px;
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;;EAEtB,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;;EAEvB,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;;EAEzB,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;;EAErB,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;;EAE1B,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;;EAEhB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,oBAAoB;;EAEpB,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,qBAAqB;;EAErB,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;;EAEvB,kCAAkC;EAClC,+CAA+C;EAC/C,sFAAsF;EACtF,sFAAsF;EACtF,2FAA2F;EAC3F,0FAA0F;EAC1F,qDAAqD;;EAErD,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;;EAErB,gBAAgB;EAChB,qDAAqD;EACrD,gDAAgD;EAChD,qDAAqD;EACrD,4DAA4D;;EAE5D,eAAe;EACf,uFAAuF;EACvF,iEAAiE;;EAEjE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;;EAEpB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;;EAErB,iBAAiB;EACjB,uBAAuB;;EAEvB,gEAAgE;EAChE,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;;EAEtB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAIA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,qCAA6B;EAA7B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,gCAAgC;EAChC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,2GAA2G;EAC3G,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mFAAmF;AACrF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,YAAY;AACZ;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,qCAAqC;EACrC,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;EACzB,OAAO;EACP,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,0BAA0B;EAC1B,0BAA0B;EAC1B,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,+BAA+B;EAC/B,4BAA4B;EAC5B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,4CAA4C;EAC5C,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,iBAAiB,qCAAqC,EAAE,qBAAqB,EAAE;AAC/E,iBAAiB,gCAAgC,EAAE,0BAA0B,EAAE;AAC/E,iBAAiB,gCAAgC,EAAE,0BAA0B,EAAE;AAC/E,gBAAgB,+BAA+B,EAAE,yBAAyB,EAAE;AAC5E,cAAc,6BAA6B,EAAE,kBAAkB,EAAE;AACjE,gBAAgB,+BAA+B,EAAE,oBAAoB,EAAE;AACvE,cAAc,6BAA6B,EAAE,kBAAkB,EAAE;;AAEjE,oCAAoC;AACpC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,iDAAiD;AACjD;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;EACjC,qCAAqC;EACrC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA,wCAAwC;AACxC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,qBAAqB;EACrB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,qCAAqC;AACrC;EACE,0BAA0B;EAC1B,cAAc;EACd,0EAA0E;AAC5E;;AAEA;EACE,+BAA+B;EAC/B,4EAA4E;EAC5E,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,gCAAgC;AAChC;EACE,0BAA0B;EAC1B,cAAc;EACd,4EAA4E;AAC9E;;AAEA;EACE,+BAA+B;EAC/B,8EAA8E;EAC9E,2BAA2B;AAC7B;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,cAAc;EACd,2EAA2E;AAC7E;;AAEA;EACE,8BAA8B;EAC9B,6EAA6E;EAC7E,2BAA2B;AAC7B;;AAEA,iCAAiC;AACjC;EACE,0BAA0B;EAC1B,cAAc;EACd,2EAA2E;AAC7E;;AAEA;EACE,+BAA+B;EAC/B,6EAA6E;EAC7E,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;EACE,uBAAuB;EACvB,cAAc;EACd,2EAA2E;AAC7E;;AAEA;EACE,mBAAmB;EACnB,6EAA6E;EAC7E,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,sBAAsB;EACtB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,uCAAuC;AACvC;EACE,uBAAuB;EACvB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,oDAAoD;AACpD;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,eAAe;EACf,+BAA+B;AACjC;;AAEA,6CAA6C;AAC7C;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA,wCAAwC;AACxC;EACE,qCAAqC;EACrC,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;EAGE,kBAAkB;EAClB,iCAAiC;EACjC,4BAA4B;EAC5B,eAAe;EACf,6BAA6B;EAC7B,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;;;EAGE,aAAa;EACb,4BAA4B;EAC5B,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;EACnB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA,UAAU;AACV;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,+BAA+B;EAC/B,UAAU;EACV,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,8DAA8D;EAC9D,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,0BAA0B;EAC1B,aAAa;EACb,+BAA+B;EAC/B,4BAA4B;EAC5B,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,sCAAsC,EAAE;EAC3D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA,aAAa,sBAAsB,EAAE;AACrC,aAAa,qBAAqB,EAAE;AACpC,aAAa,sBAAsB,EAAE;AACrC,aAAa,qBAAqB,EAAE;AACpC,aAAa,sBAAsB,EAAE;AACrC,aAAa,qBAAqB,EAAE;;AAEpC,qBAAqB;AACrB;EACE,iGAAiG;EACjG,0BAA0B;EAC1B,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,yCAAyC;EACzC,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,SAAO;AACT;;AAEA,+CAA+C;AAC/C;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;;;AAIA;EACE,4BAA4B;EAC5B,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,4BAA4B;AAC5B;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;;EAEE,4BAA4B;EAC5B,wBAAwB;EACxB,2BAA2B;EAC3B,YAAY;AACd;;AAEA,uDAAuD;AACvD;;;EAGE,kCAAkC;EAClC,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;;;EAGE,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,mCAAmC;AACnC;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;;;8CAG8C;;AAE9C;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA,uBAAuB;EACvB;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA,eAAe;EACf;IACE,0BAA0B;EAC5B;;EAEA,oBAAoB;EACpB;IACE,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n:root {\n  /* Brand - HIDROVEN Navy */\n  --primary: #162A5A;\n  --primary-dark: #0D1E42;\n  --primary-darker: #08122B;\n  --primary-light: #1E3A7A;\n  --primary-ultralight: #E8EFF9;\n  --primary-50: #F0F4FA;\n  --primary-100: #E1E8F4;\n  --primary-200: #C2D0E9;\n  --primary-300: #A3B9DE;\n  --primary-400: #84A1D3;\n  --primary-500: #162A5A;\n  --primary-600: #12244F;\n  --primary-700: #0D1E42;\n\n  /* Accent - HIDROVEN Cyan */\n  --accent: #4AADE3;\n  --accent-dark: #2D8EC4;\n  --accent-light: #E0F4FF;\n  \n  /* Sidebar Gradients */\n  --sidebar-bg-start: #0D1E42;\n  --sidebar-bg-end: #162A5A;\n\n  /* Semantic - States (Tricolor / Natural) */\n  --success: #2E7D32;\n  --success-dark: #1B5E20;\n  --success-light: #E8F5E9;\n  --warning: #E65100;\n  --warning-dark: #BF360C;\n  --warning-light: #FFF3E0;\n  --danger: #B71C1C;\n  --danger-dark: #7F0000;\n  --danger-light: #FFEBEE;\n  --info: #0891b2;\n  --info-light: #cffafe;\n  --purple: #7c3aed;\n  --purple-light: #ede9fe;\n  --teal: #0d9488;\n  --teal-light: #ccfbf1;\n\n  /* State-specific colors */\n  --state-borrador: #6b7280;\n  --state-evaluacion: #d97706;\n  --state-verificacion: #0891b2;\n  --state-aprobado: #0d9488;\n  --state-enviado: #1e3a5f;\n  --state-recibido: #0f766e;\n  --state-rechazado: #b91c1c;\n\n  /* Neutral Grays */\n  --gray-50: #f8fafc;\n  --gray-100: #f1f5f9;\n  --gray-200: #e2e8f0;\n  --gray-300: #cbd5e1;\n  --gray-400: #94a3b8;\n  --gray-500: #64748b;\n  --gray-600: #475569;\n  --gray-700: #334155;\n  --gray-800: #1e293b;\n  --gray-900: #0f172a;\n  --white: #ffffff;\n\n  /* Backgrounds */\n  --bg: #EEF4FC;\n  --bg-card: #ffffff;\n  --bg-subtle: #f8fafc;\n\n  /* Text */\n  --text: #0f172a;\n  --text-secondary: #475569;\n  --text-muted: #64748b;\n\n  /* Borders */\n  --border: #e2e8f0;\n  --border-light: #f1f5f9;\n\n  /* Shadows - Soft & Professional */\n  --shadow-xs: 0 1px 2px 0 rgba(15, 23, 42, 0.04);\n  --shadow-sm: 0 1px 3px 0 rgba(15, 23, 42, 0.06), 0 1px 2px -1px rgba(15, 23, 42, 0.06);\n  --shadow: 0 4px 6px -1px rgba(15, 23, 42, 0.08), 0 2px 4px -2px rgba(15, 23, 42, 0.08);\n  --shadow-md: 0 10px 15px -3px rgba(15, 23, 42, 0.08), 0 4px 6px -4px rgba(15, 23, 42, 0.08);\n  --shadow-lg: 0 20px 25px -5px rgba(15, 23, 42, 0.1), 0 8px 10px -6px rgba(15, 23, 42, 0.1);\n  --shadow-xl: 0 25px 50px -12px rgba(15, 23, 42, 0.15);\n\n  /* Border Radius - More Rounded */\n  --radius-xs: 6px;\n  --radius-sm: 8px;\n  --radius: 10px;\n  --radius-md: 14px;\n  --radius-lg: 18px;\n  --radius-xl: 24px;\n  --radius-full: 9999px;\n\n  /* Transitions */\n  --transition-fast: 150ms cubic-bezier(0.4, 0, 0.2, 1);\n  --transition: 200ms cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-slow: 300ms cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-bounce: 350ms cubic-bezier(0.34, 1.56, 0.64, 1);\n\n  /* Typography */\n  --font-sans: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  --font-mono: 'Fira Code', ui-monospace, SFMono-Regular, monospace;\n\n  /* Layout */\n  --header-height: 72px;\n  --sidebar-width: 270px;\n  --sidebar-collapsed: 72px;\n}\n\n[data-theme=\"dark\"] {\n  --bg: #1a1c23;\n  --bg-card: #252836;\n  --bg-subtle: #2d303e;\n  \n  --text: #ffffff;\n  --text-secondary: #e0e0e0;\n  --text-muted: #d0d0d0;\n  \n  --border: #374151;\n  --border-light: #2d303e;\n\n  /* Modifying specific semantic/structural colors for dark mode */\n  --primary-ultralight: #252836;\n  --primary-50: #1a1c23;\n  --primary-100: #2d303e;\n  --primary-200: #374151;\n\n  --shadow-xs: none;\n  --shadow-sm: none;\n  --shadow: none;\n  --shadow-md: none;\n  --shadow-lg: none;\n  --shadow-xl: none;\n}\n\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');\n\nbody {\n  font-family: var(--font-sans);\n  background-color: var(--bg);\n  color: var(--text);\n  line-height: 1.6;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overflow-x: hidden;\n}\n\n::selection {\n  background: var(--primary-light);\n  color: var(--primary-darker);\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--gray-100);\n  border-radius: var(--radius-full);\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--gray-300);\n  border-radius: var(--radius-full);\n  transition: var(--transition);\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--gray-400);\n}\n\n/* Layout */\n.layout {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.layout-content {\n  display: flex;\n  flex: 1;\n  margin-top: var(--header-height);\n}\n\n.main-content {\n  flex: 1;\n  padding: 24px;\n  background: var(--bg);\n  overflow-y: auto;\n  min-height: calc(100vh - var(--header-height));\n}\n\n.loading {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  gap: 16px;\n  font-size: 16px;\n  color: var(--text-muted);\n}\n\n.loading::before {\n  content: '';\n  width: 40px;\n  height: 40px;\n  border: 3px solid var(--gray-200);\n  border-top-color: var(--primary);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n/* Header */\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 24px;\n  height: var(--header-height);\n  background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 50%, var(--primary-darker) 100%);\n  color: var(--white);\n  box-shadow: var(--shadow-md);\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  backdrop-filter: blur(10px);\n}\n\n.header::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.logo {\n  font-size: 20px;\n  font-weight: 800;\n  margin: 0;\n  letter-spacing: -0.5px;\n  text-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.subtitle {\n  font-size: 12px;\n  opacity: 0.85;\n  font-weight: 400;\n  letter-spacing: 0.3px;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.user-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: var(--radius-full);\n  background: rgba(255,255,255,0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 14px;\n  border: 2px solid rgba(255,255,255,0.3);\n  transition: var(--transition);\n}\n\n.user-avatar:hover {\n  background: rgba(255,255,255,0.3);\n  transform: scale(1.05);\n}\n\n.user-role {\n  font-size: 11px;\n  opacity: 0.75;\n  font-weight: 400;\n  background: rgba(255,255,255,0.15);\n  padding: 2px 8px;\n  border-radius: var(--radius-full);\n}\n\n.btn-logout {\n  padding: 8px 16px;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: var(--white);\n  border-radius: var(--radius);\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: var(--transition);\n  backdrop-filter: blur(4px);\n}\n\n.btn-logout:hover {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.4);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n}\n\n.btn-logout:active {\n  transform: translateY(0);\n}\n\n/* Sidebar */\n.sidebar {\n  width: var(--sidebar-width);\n  background: var(--bg-card);\n  border-right: 1px solid var(--border);\n  padding: 16px 0;\n  box-shadow: var(--shadow-xs);\n  position: fixed;\n  top: var(--header-height);\n  left: 0;\n  bottom: 0;\n  overflow-y: auto;\n  z-index: 100;\n  transition: var(--transition);\n}\n\n.menu {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.menu li a {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 20px;\n  margin: 4px 12px;\n  text-decoration: none;\n  color: var(--gray-600);\n  font-size: 14px;\n  font-weight: 500;\n  transition: var(--transition);\n  border-radius: var(--radius);\n  position: relative;\n  overflow: hidden;\n}\n\n.menu li a::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 3px;\n  background: var(--primary);\n  border-radius: 0 2px 2px 0;\n  transform: scaleY(0);\n  transition: var(--transition);\n}\n\n.menu li a:hover {\n  background: var(--gray-50);\n  color: var(--primary);\n  transform: translateX(4px);\n}\n\n.menu li a:hover::before {\n  transform: scaleY(1);\n}\n\n.menu li a.active {\n  background: var(--primary-ultralight);\n  color: var(--primary);\n  font-weight: 600;\n}\n\n.menu li a.active::before {\n  transform: scaleY(1);\n}\n\n.menu .icon {\n  font-size: 18px;\n  width: 24px;\n  text-align: center;\n  transition: var(--transition);\n}\n\n.menu li a:hover .icon {\n  transform: scale(1.1);\n}\n\n/* Cards */\n.card {\n  background: var(--bg-card);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  padding: 24px;\n  transition: var(--transition);\n  border: 1px solid var(--border);\n}\n\n.card:hover {\n  box-shadow: var(--shadow);\n}\n\n/* Stats - Summary Cards with Icons */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.stat-card {\n  background: var(--bg-card);\n  padding: 20px;\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--border);\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  transition: var(--transition);\n}\n\n.stat-card:hover {\n  box-shadow: var(--shadow);\n  transform: translateY(-2px);\n}\n\n.stat-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: var(--radius);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n  flex-shrink: 0;\n}\n\n.stat-icon.primary {\n  background: var(--primary-ultralight);\n  color: var(--primary);\n}\n\n.stat-icon.success {\n  background: var(--success-light);\n  color: var(--success);\n}\n\n.stat-icon.warning {\n  background: var(--warning-light);\n  color: var(--warning);\n}\n\n.stat-icon.danger {\n  background: var(--danger-light);\n  color: var(--danger);\n}\n\n.stat-icon.info {\n  background: var(--info-light);\n  color: var(--info);\n}\n\n.stat-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.stat-card h3 {\n  font-size: 12px;\n  color: var(--text-muted);\n  margin-bottom: 6px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.stat-number {\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--text);\n  line-height: 1;\n}\n\n/* Tables */\n.table-container {\n  background: var(--bg-card);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  overflow-x: auto;\n  border: 1px solid var(--border);\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.table th {\n  background: var(--bg);\n  padding: 14px 18px;\n  text-align: center;\n  font-weight: 600;\n  color: var(--primary);\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  border-bottom: 2px solid var(--accent);\n  white-space: nowrap;\n}\n\n.table td {\n  padding: 16px 18px;\n  font-size: 14px;\n  border-bottom: 1px solid var(--border-light);\n  color: var(--text-secondary);\n  vertical-align: middle;\n}\n\n.table tbody tr {\n  transition: var(--transition);\n}\n\n.table tbody tr:nth-child(even) {\n  background: var(--bg-subtle);\n}\n\n.table tbody tr:hover {\n  background: var(--primary-ultralight);\n}\n\n.table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* Badges - Capsule Style */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 12px;\n  border-radius: var(--radius-full);\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  transition: var(--transition);\n}\n\n.badge:hover {\n  transform: scale(1.05);\n}\n\n.badge-primary { background: var(--primary-ultralight); color: var(--primary); }\n.badge-success { background: var(--success-light); color: var(--success-dark); }\n.badge-warning { background: var(--warning-light); color: var(--warning-dark); }\n.badge-danger { background: var(--danger-light); color: var(--danger-dark); }\n.badge-info { background: var(--info-light); color: var(--info); }\n.badge-purple { background: var(--purple-light); color: var(--purple); }\n.badge-teal { background: var(--teal-light); color: var(--teal); }\n\n/* Estado Badges - Semantic Colors */\n.estado-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 12px;\n  border-radius: var(--radius-full);\n  font-size: 12px;\n  font-weight: 600;\n  transition: var(--transition);\n  border: 1px solid transparent;\n  white-space: nowrap;\n  width: max-content;\n}\n\n.estado-badge:hover {\n  transform: scale(1.05);\n}\n\n/* State-specific colors - Professional & Sober */\n.estado-badge.borrador {\n  background: var(--gray-100);\n  color: var(--state-borrador);\n  border-color: var(--gray-200);\n}\n\n.estado-badge.en_evaluacion_factibilidad {\n  background: var(--warning-light);\n  color: var(--state-evaluacion);\n  border-color: var(--warning);\n}\n\n.estado-badge.verificacion_final {\n  background: var(--info-light);\n  color: var(--state-verificacion);\n  border-color: var(--info);\n}\n\n.estado-badge.aprobado_para_envio {\n  background: var(--success-light);\n  color: var(--state-aprobado);\n  border-color: var(--success);\n}\n\n.estado-badge.enviado {\n  background: var(--primary-ultralight);\n  color: var(--state-enviado);\n  border-color: var(--primary-200);\n}\n\n.estado-badge.recibido {\n  background: var(--teal-light);\n  color: var(--state-recibido);\n  border-color: var(--teal);\n}\n\n.estado-badge.rechazado {\n  background: var(--danger-light);\n  color: var(--state-rechazado);\n  border-color: var(--danger);\n}\n\n.role-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 4px 12px;\n  border-radius: var(--radius-full);\n  background: var(--primary-ultralight);\n  color: var(--primary);\n  font-size: 12px;\n  font-weight: 600;\n  transition: var(--transition);\n  white-space: nowrap;\n}\n\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 12px;\n  border-radius: var(--radius-full);\n  font-size: 12px;\n  font-weight: 600;\n  transition: var(--transition);\n}\n\n.status-badge::before {\n  content: '';\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.status-badge.activo {\n  background: var(--success-light);\n  color: var(--success-dark);\n}\n\n.status-badge.inactivo {\n  background: var(--danger-light);\n  color: var(--danger-dark);\n}\n\n.tipo-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 12px;\n  border-radius: var(--radius-full);\n  font-size: 12px;\n  font-weight: 600;\n  transition: var(--transition);\n}\n\n.tipo-badge.emisora {\n  background: var(--primary-ultralight);\n  color: var(--primary);\n  border: 1px solid var(--primary-200);\n}\n\n.tipo-badge.receptora {\n  background: var(--purple-light);\n  color: var(--purple);\n  border: 1px solid var(--purple);\n}\n\n/* Buttons - estilo Tailwind/Bootstrap */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px 20px;\n  border: none;\n  border-radius: var(--radius);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  text-decoration: none;\n  white-space: nowrap;\n  font-family: var(--font-sans);\n  position: relative;\n  overflow: hidden;\n}\n\n.btn:active {\n  transform: scale(0.97);\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n/* Primary - Navy Blue Professional */\n.btn-primary {\n  background: var(--primary);\n  color: #ffffff;\n  box-shadow: 0 1px 3px rgba(30, 58, 95, 0.2), 0 1px 2px rgba(0, 0, 0, 0.06);\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: var(--primary-dark);\n  box-shadow: 0 4px 12px rgba(30, 58, 95, 0.25), 0 2px 4px rgba(0, 0, 0, 0.08);\n  transform: translateY(-1px);\n}\n\n/* Secondary - Clean Outline */\n.btn-secondary {\n  background: #ffffff;\n  color: var(--text-secondary);\n  border: 1.5px solid var(--border);\n  box-shadow: var(--shadow-xs);\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: var(--gray-50);\n  border-color: var(--gray-300);\n  color: var(--text);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n}\n\n/* Success - Teal Professional */\n.btn-success {\n  background: var(--success);\n  color: #ffffff;\n  box-shadow: 0 1px 3px rgba(13, 148, 136, 0.2), 0 1px 2px rgba(0, 0, 0, 0.06);\n}\n\n.btn-success:hover:not(:disabled) {\n  background: var(--success-dark);\n  box-shadow: 0 4px 12px rgba(13, 148, 136, 0.25), 0 2px 4px rgba(0, 0, 0, 0.08);\n  transform: translateY(-1px);\n}\n\n/* Danger - Muted Red */\n.btn-danger {\n  background: var(--danger);\n  color: #ffffff;\n  box-shadow: 0 1px 3px rgba(185, 28, 28, 0.2), 0 1px 2px rgba(0, 0, 0, 0.06);\n}\n\n.btn-danger:hover:not(:disabled) {\n  background: var(--danger-dark);\n  box-shadow: 0 4px 12px rgba(185, 28, 28, 0.25), 0 2px 4px rgba(0, 0, 0, 0.08);\n  transform: translateY(-1px);\n}\n\n/* Warning - Amber Professional */\n.btn-warning {\n  background: var(--warning);\n  color: #ffffff;\n  box-shadow: 0 1px 3px rgba(217, 119, 6, 0.2), 0 1px 2px rgba(0, 0, 0, 0.06);\n}\n\n.btn-warning:hover:not(:disabled) {\n  background: var(--warning-dark);\n  box-shadow: 0 4px 12px rgba(217, 119, 6, 0.25), 0 2px 4px rgba(0, 0, 0, 0.08);\n  transform: translateY(-1px);\n}\n\n/* Info - Cyan Professional */\n.btn-info {\n  background: var(--info);\n  color: #ffffff;\n  box-shadow: 0 1px 3px rgba(8, 145, 178, 0.2), 0 1px 2px rgba(0, 0, 0, 0.06);\n}\n\n.btn-info:hover:not(:disabled) {\n  background: #0e7490;\n  box-shadow: 0 4px 12px rgba(8, 145, 178, 0.25), 0 2px 4px rgba(0, 0, 0, 0.08);\n  transform: translateY(-1px);\n}\n\n/* Outline - Clean Border */\n.btn-outline {\n  background: #ffffff;\n  color: var(--text-secondary);\n  border: 1.5px solid var(--border);\n  box-shadow: var(--shadow-xs);\n}\n\n.btn-outline:hover:not(:disabled) {\n  background: var(--gray-50);\n  border-color: var(--gray-300);\n  color: var(--text);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n}\n\n.btn-outline:hover:not(:disabled) {\n  background: var(--gray-50);\n  border-color: var(--gray-400);\n  color: var(--gray-900);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);\n}\n\n/* Ghost - Tailwind hover:bg-gray-100 */\n.btn-ghost {\n  background: transparent;\n  color: var(--gray-600);\n  border: 1.5px solid transparent;\n}\n\n.btn-ghost:hover:not(:disabled) {\n  background: var(--gray-100);\n  color: var(--gray-900);\n}\n\n/* Soft/Light - Tailwind bg-blue-100 text-blue-700 */\n.btn-soft-primary {\n  background: var(--primary-light);\n  color: var(--primary-dark);\n  border: 1px solid transparent;\n}\n\n.btn-soft-primary:hover:not(:disabled) {\n  background: var(--primary);\n  color: #ffffff;\n}\n\n.btn-soft-success {\n  background: var(--success-light);\n  color: var(--success-dark);\n  border: 1px solid transparent;\n}\n\n.btn-soft-success:hover:not(:disabled) {\n  background: var(--success);\n  color: #ffffff;\n}\n\n.btn-soft-danger {\n  background: var(--danger-light);\n  color: var(--danger-dark);\n  border: 1px solid transparent;\n}\n\n.btn-soft-danger:hover:not(:disabled) {\n  background: var(--danger);\n  color: #ffffff;\n}\n\n/* Link */\n.btn-link {\n  color: var(--primary);\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n  transition: var(--transition);\n  background: none;\n  border: none;\n  padding: 4px 8px;\n  border-radius: var(--radius-xs);\n}\n\n.btn-link:hover {\n  background: var(--primary-ultralight);\n  color: var(--primary-dark);\n}\n\n/* Small buttons */\n.btn-small, .btn-sm {\n  padding: 6px 12px;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: var(--radius-sm);\n}\n\n/* Large buttons */\n.btn-lg {\n  padding: 14px 28px;\n  font-size: 16px;\n  border-radius: var(--radius-md);\n}\n\n/* Action buttons - Professional Soft Style */\n.btn-approve {\n  background: var(--success-light);\n  color: var(--success-dark);\n  border: 1px solid var(--success);\n}\n\n.btn-approve:hover:not(:disabled) {\n  background: var(--success);\n  color: #ffffff;\n  box-shadow: 0 2px 8px rgba(13, 148, 136, 0.25);\n  transform: translateY(-1px);\n}\n\n.btn-reject {\n  background: var(--danger-light);\n  color: var(--danger-dark);\n  border: 1px solid var(--danger);\n}\n\n.btn-reject:hover:not(:disabled) {\n  background: var(--danger);\n  color: #ffffff;\n  box-shadow: 0 2px 8px rgba(185, 28, 28, 0.25);\n  transform: translateY(-1px);\n}\n\n.btn-edit {\n  background: var(--warning-light);\n  color: var(--warning-dark);\n  border: 1px solid var(--warning);\n}\n\n.btn-edit:hover:not(:disabled) {\n  background: var(--warning);\n  color: #ffffff;\n  box-shadow: 0 2px 8px rgba(217, 119, 6, 0.25);\n  transform: translateY(-1px);\n}\n\n.btn-password {\n  background: var(--purple-light);\n  color: var(--purple);\n  border: 1px solid var(--purple);\n}\n\n.btn-password:hover:not(:disabled) {\n  background: var(--purple);\n  color: #ffffff;\n  box-shadow: 0 2px 8px rgba(124, 58, 237, 0.25);\n  transform: translateY(-1px);\n}\n\n/* View detail button - eye icon style */\n.btn-view {\n  background: var(--primary-ultralight);\n  color: var(--primary);\n  border: 1px solid var(--primary-200);\n}\n\n.btn-view:hover:not(:disabled) {\n  background: var(--primary);\n  color: #ffffff;\n  box-shadow: 0 2px 8px rgba(30, 58, 95, 0.25);\n  transform: translateY(-1px);\n}\n\n/* Spinner inside buttons */\n.spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: #ffffff;\n  border-radius: 50%;\n  animation: spin 0.6s linear infinite;\n}\n\n/* Forms */\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 16px;\n}\n\n.form-group label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--gray-700);\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  padding: 10px 14px;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius);\n  font-size: 14px;\n  transition: var(--transition);\n  background: var(--white);\n  font-family: var(--font-sans);\n}\n\n.form-group input:hover,\n.form-group select:hover,\n.form-group textarea:hover {\n  border-color: var(--gray-400);\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px var(--primary-light);\n  transform: translateY(-1px);\n}\n\n.form-group input:disabled,\n.form-group select:disabled {\n  background: var(--gray-100);\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n}\n\n/* Error messages */\n.error-message {\n  background: var(--danger-light);\n  color: var(--danger-dark);\n  padding: 14px 16px;\n  border-radius: var(--radius);\n  font-size: 14px;\n  margin-bottom: 16px;\n  border-left: 4px solid var(--danger);\n  animation: slideInLeft 0.3s ease;\n}\n\n/* Empty state */\n.empty-message {\n  text-align: center;\n  color: var(--text-muted);\n  padding: 60px 24px;\n  font-size: 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.empty-message::before {\n  content: '📋';\n  font-size: 48px;\n  opacity: 0.5;\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(8px);\n  animation: fadeIn 0.2s ease;\n}\n\n.modal-content {\n  background: var(--bg-card);\n  padding: 28px;\n  border-radius: var(--radius-lg);\n  width: 90%;\n  max-width: 520px;\n  box-shadow: var(--shadow-xl);\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: modalSlideIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n  border: 1px solid var(--border);\n}\n\n.modal-content.modal-lg {\n  max-width: 720px;\n}\n\n.modal-content h3 {\n  margin-bottom: 20px;\n  color: var(--gray-900);\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.modal-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 8px;\n}\n\n/* Section headers */\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--border);\n}\n\n.section-header h3 {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--gray-900);\n}\n\n/* Filtros */\n.filtros-container {\n  background: var(--bg-card);\n  padding: 20px;\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  margin-bottom: 24px;\n  border: 1px solid var(--border);\n}\n\n.filtros-container h3 {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 16px;\n  color: var(--gray-800);\n}\n\n.filtros-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n}\n\n.filtros-rapidos {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes fadeInUp {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes fadeInDown {\n  from { opacity: 0; transform: translateY(-20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes fadeInLeft {\n  from { opacity: 0; transform: translateX(-20px); }\n  to { opacity: 1; transform: translateX(0); }\n}\n\n@keyframes fadeInRight {\n  from { opacity: 0; transform: translateX(20px); }\n  to { opacity: 1; transform: translateX(0); }\n}\n\n@keyframes slideInLeft {\n  from { opacity: 0; transform: translateX(-100%); }\n  to { opacity: 1; transform: translateX(0); }\n}\n\n@keyframes slideInUp {\n  from { opacity: 0; transform: translateY(100%); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes modalSlideIn {\n  from { opacity: 0; transform: scale(0.9) translateY(20px); }\n  to { opacity: 1; transform: scale(1) translateY(0); }\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}\n\n@keyframes bounce {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-6px); }\n}\n\n@keyframes shimmer {\n  0% { background-position: -200% 0; }\n  100% { background-position: 200% 0; }\n}\n\n.animate-fade-in {\n  animation: fadeIn 0.4s ease;\n}\n\n.animate-fade-in-up {\n  animation: fadeInUp 0.5s ease;\n}\n\n.animate-fade-in-down {\n  animation: fadeInDown 0.4s ease;\n}\n\n.animate-slide-in-left {\n  animation: fadeInLeft 0.4s ease;\n}\n\n.animate-slide-in-right {\n  animation: fadeInRight 0.4s ease;\n}\n\n.animate-bounce {\n  animation: bounce 0.5s ease;\n}\n\n.animate-pulse {\n  animation: pulse 2s ease infinite;\n}\n\n.stagger-1 { animation-delay: 0.05s; }\n.stagger-2 { animation-delay: 0.1s; }\n.stagger-3 { animation-delay: 0.15s; }\n.stagger-4 { animation-delay: 0.2s; }\n.stagger-5 { animation-delay: 0.25s; }\n.stagger-6 { animation-delay: 0.3s; }\n\n/* Skeleton loading */\n.skeleton {\n  background: linear-gradient(90deg, var(--gray-100) 25%, var(--gray-200) 50%, var(--gray-100) 75%);\n  background-size: 200% 100%;\n  animation: shimmer 1.5s infinite;\n  border-radius: var(--radius);\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .main-content {\n    padding: 20px;\n  }\n\n  .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .main-content {\n    padding: 16px;\n    margin-left: 0;\n  }\n\n  .stats-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .header {\n    padding: 0 16px;\n  }\n\n  .subtitle {\n    display: none;\n  }\n\n  .section-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .filtros-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .table-container {\n    overflow-x: auto;\n  }\n\n  .table {\n    min-width: 600px;\n  }\n\n  .modal-content {\n    width: 95%;\n    padding: 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .header-right {\n    gap: 8px;\n  }\n\n  .user-info span:not(.user-avatar):not(.user-role) {\n    display: none;\n  }\n\n  .btn-logout {\n    padding: 6px 10px;\n    font-size: 12px;\n  }\n\n  .stat-card {\n    padding: 16px;\n  }\n\n  .stat-number {\n    font-size: 28px;\n  }\n}\n\n/* Grupo de input de cédula compuesto (V/E + Número) */\n.cedula-input-group {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  width: 100%;\n}\n\n.cedula-input-group .select-nacionalidad {\n  width: 80px;\n  min-width: 80px;\n  padding: 10px 12px;\n  border-radius: var(--radius-sm, 8px);\n  border: 1.5px solid var(--border, #cbd5e1);\n  background-color: var(--bg-card, #ffffff);\n  color: var(--text, #0f172a);\n  font-weight: 600;\n  outline: none;\n  transition: var(--transition, all 0.2s);\n}\n\n.cedula-input-group .select-nacionalidad:focus {\n  border-color: var(--primary, #1e3a5f);\n  box-shadow: 0 0 0 3px rgba(30, 58, 95, 0.15);\n}\n\n[data-theme=\"dark\"] .cedula-input-group .select-nacionalidad {\n  border-color: var(--gray-700, #475569);\n  background-color: var(--gray-800, #1e293b);\n  color: var(--gray-100, #f8fafc);\n}\n\n.cedula-input-group .input-cedula-num {\n  flex: 1;\n}\n\n/* Unified Table Card Layout (from Dashboard) */\n.table-card-container {\n  background: var(--bg-card);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n  margin-top: 24px;\n}\n\n.table-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 18px 24px;\n  background: var(--gray-50);\n  border-bottom: 1px solid var(--border);\n}\n\n.table-card-header h3 {\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--gray-800);\n  margin: 0;\n}\n\n.table-count-pill {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  background: var(--gray-200);\n  padding: 4px 12px;\n  border-radius: var(--radius-full);\n}\n\n.table-search-bar {\n  padding: 15px 24px;\n  border-bottom: 1px solid var(--border-light);\n  background: var(--white);\n}\n\n.table-search-input {\n  width: 100%;\n  max-width: 400px;\n  padding: 10px 15px;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  outline: none;\n  font-size: 14px;\n  transition: var(--transition);\n  background-color: var(--white);\n  color: var(--text);\n}\n\n.table-search-input:focus {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px var(--primary-ultralight);\n}\n\n.table-pagination-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 24px;\n  border-top: 1px solid var(--border-light);\n  background: var(--white);\n}\n\n.table-pagination-button {\n  padding: 8px 16px;\n  border-radius: 6px;\n  border: 1px solid var(--border);\n  background: var(--white);\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 13px;\n  color: var(--gray-700);\n  transition: var(--transition);\n}\n\n.table-pagination-button:hover:not(:disabled) {\n  background: var(--gray-50);\n  border-color: var(--gray-400);\n}\n\n.table-pagination-button:disabled {\n  background: var(--gray-100);\n  color: var(--text-muted);\n  cursor: not-allowed;\n  border-color: var(--border-light);\n}\n\n.table-pagination-info {\n  font-size: 14px;\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n\r\n\n[data-theme=\"dark\"] .btn-secondary {\n  background: var(--bg-subtle);\n  color: #ffffff;\n  border-color: var(--border);\n}\n\n[data-theme=\"dark\"] .btn-secondary:hover:not(:disabled) {\n  background: var(--primary-100);\n}\n\n/* Dark mode Bandeja fixes */\n[data-theme=\"dark\"] .table-card-header {\n  background: var(--bg-card);\n  border-bottom-color: var(--border);\n}\n\n[data-theme=\"dark\"] .table-card-header h3 {\n  color: #ffffff;\n}\n\n[data-theme=\"dark\"] .table th {\n  background: var(--bg-subtle);\n  color: #ffffff;\n  border-bottom-color: var(--border);\n  font-weight: bold;\n}\n\n[data-theme=\"dark\"] .table td strong {\n  color: #ffffff;\n  font-weight: bold;\n}\n\n[data-theme=\"dark\"] .table-search-bar {\n  background: var(--bg-card);\n  border-bottom-color: var(--border);\n}\n\n[data-theme=\"dark\"] .table-search-input {\n  background: var(--bg-subtle);\n  color: #ffffff;\n  border-color: var(--border);\n}\n\n[data-theme=\"dark\"] .table-pagination-bar {\n  background: var(--bg-card);\n  border-top-color: var(--border);\n}\n\n[data-theme=\"dark\"] .table-pagination-button {\n  background: var(--bg-subtle);\n  color: #ffffff;\n  border-color: var(--border);\n}\n\n[data-theme=\"dark\"] .table-pagination-button:disabled {\n  background: var(--bg-card);\n  color: var(--text-muted);\n}\n\n[data-theme=\"dark\"] .table-pagination-info {\n  color: #ffffff;\n}\n\n[data-theme=\"dark\"] .enviados-header h2 {\n  color: #ffffff;\n}\n\n[data-theme=\"dark\"] .table-count-pill {\n  color: #ffffff;\n  background: var(--primary);\n  border: 1px solid var(--border);\n}\n\n[data-theme=\"dark\"] .btn-link {\n  color: #60a5fa;\n}\n\n[data-theme=\"dark\"] .btn-link:hover {\n  color: #93c5fd;\n}\n\n/* Global dark mode override for disabled inputs and selects */\n[data-theme=\"dark\"] .form-group input:disabled,\n[data-theme=\"dark\"] .form-group select:disabled {\n  background: var(--bg-subtle);\n  color: var(--text-muted);\n  border-color: var(--border);\n  opacity: 0.8;\n}\n\n/* Global dark mode overrides for form group controls */\n[data-theme=\"dark\"] .form-group input,\n[data-theme=\"dark\"] .form-group select,\n[data-theme=\"dark\"] .form-group textarea {\n  background-color: var(--bg-subtle);\n  color: var(--text);\n  border-color: var(--border);\n}\n\n[data-theme=\"dark\"] .form-group input:hover,\n[data-theme=\"dark\"] .form-group select:hover,\n[data-theme=\"dark\"] .form-group textarea:hover {\n  border-color: var(--gray-500);\n}\n\n[data-theme=\"dark\"] .form-group input:focus,\n[data-theme=\"dark\"] .form-group select:focus,\n[data-theme=\"dark\"] .form-group textarea:focus {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25);\n}\n\n[data-theme=\"dark\"] .form-group label {\n  color: var(--text-secondary);\n}\n\n/* Pestañas Globales (Pill style) */\n.reporte-tab-btn {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  padding: 12px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: normal;\n  transition: all 0.2s;\n  background: transparent;\n  color: var(--text-muted);\n}\n\n.reporte-tab-btn.active {\n  background: #f1f5f9;\n  color: #0f172a;\n  font-weight: bold;\n}\n\n[data-theme=\"dark\"] .reporte-tab-btn.active {\n  background: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n}\n\n[data-theme=\"dark\"] .reporte-tab-btn:not(.active) {\n  color: var(--text-muted);\n}\n\n[data-theme=\"dark\"] .reporte-tab-btn:hover:not(.active) {\n  background: rgba(255, 255, 255, 0.05);\n  color: #ffffff;\n}\n\n/* =========================================\n   RESPONSIVE DESIGN (Tablets y Móviles)\n   Añadido sin romper el diseño de escritorio\n   ========================================= */\n\n@media (max-width: 992px) {\n  .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  :root {\n    --header-height: 60px;\n  }\n\n  .layout-content {\n    flex-direction: column;\n  }\n  \n  .main-content {\n    padding: 16px;\n    width: 100vw;\n  }\n\n  /* Header adjustments */\n  .header {\n    padding: 0 16px;\n  }\n\n  .logo-hidroven {\n    display: none;\n  }\n\n  .user-profile {\n    display: none;\n  }\n\n  .btn-logout .logout-text {\n    display: none;\n  }\n  \n  .btn-logout {\n    padding: 8px;\n  }\n\n  /* Stats Grid */\n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n\n  /* Table Container */\n  .table-container {\n    border-radius: var(--radius-sm);\n  }\n  \n  .table th, .table td {\n    padding: 12px;\n    font-size: 13px;\n  }\n\n  .btn {\n    padding: 8px 16px;\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 480px) {\n  .header-left {\n    gap: 8px;\n  }\n  \n  .logo-ministerio {\n    height: 32px;\n  }\n  \n  .main-content {\n    padding: 12px;\n  }\n  \n  .table th, .table td {\n    padding: 10px 8px;\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
